import { Component, OnInit, OnDestroy } from '@angular/core';
import { UrlHistoryService } from '../../services/url.history.service';
import {TranslateService} from "../../services/translate.service";
import { Subscription } from 'rxjs';
import { skip } from 'rxjs/operators';
import { ProfileInfo } from '../../models/Profile';
import { AuthorizedApiService } from '../../services/authorized-api.service';
import { AppStateService } from '../../services/app-state.service';
import { HackUtils } from '../../utils/Utils';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { AppState } from '../../models/AppState';
import { CircleButtonComponent } from '../buttons/circle-button.component';
import { CommonModule } from '@angular/common';
import { LoadingSpinnerComponent } from '../ui/loading-spinner-component';
import { CleanEventsDialogComponent } from '../dialogs/clean-events-dialog-component';
import {ModalService} from '../../services/modal.service';

@Component({
  selector: 'app-gdpr',
  standalone: true,
  imports: [
    CircleButtonComponent,
    CommonModule,
    LoadingSpinnerComponent
  ],
  templateUrl: './gdpr.component.html',
  styleUrls: ['./gdpr.component.css']
})
export class GdprComponent implements OnInit, OnDestroy {

  profileInfo: ProfileInfo | null = null;
  app: AppState | null = null;
  public isLoading: boolean = false;
  private profileSub: Subscription | undefined;
  private appStateSub: Subscription | undefined;
  private signoutSub: Subscription  | undefined;

  constructor(private identityService: UrlHistoryService, private api: AuthorizedApiService,
              private translate: TranslateService, private appStateService: AppStateService,
              private modalService:ModalService,
              private router: Router, private authService: AuthService) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.appStateSub = this.appStateService.observeAppState().subscribe(appState => {
      this.app = appState;
      this.fetchProfileInfo();
    });
  }

  ngOnDestroy() {
    this.profileSub?.unsubscribe();
    this.appStateSub?.unsubscribe();
    this.signoutSub?.unsubscribe();
  }

  private fetchProfileInfo() {
    this.profileSub = this.api.getProfileInfo().subscribe(res => {
      this.profileInfo = res;
      this.isLoading = false;
    });
  }

  cleanEvents(): void {
    this.modalService.show(CleanEventsDialogComponent, {
      data: {
        title: 'Rensa händelser?',
        message: 'Alla händelser från din händelselista kommer att raderas.',
        confirmText: 'Rensa',
        abortText: 'Avbryt',
        action: 'cleanEvents'
      }
    });
  }

  wipeProfile(): void {
    this.modalService.show(CleanEventsDialogComponent, {
      data: {
        title: 'Är du säker på att du vill radera profilen?',
        message: 'All data, inklusive kvitton, rabattkort, rabattkoder etc., kommer att försvinna.',
        confirmText: 'Radera',
        abortText: 'Avbryt',
        action: 'wipeProfile'
      }
    }).subscribe(wiped => {
      // Still signed in, the app would sign in again and create a new profile for the same login
      if (wiped) {
        this.logout();
      }
    });
  }

  private async logout() {
    this.isLoading = true;
    this.signoutSub = this.appStateService.observeAppState().pipe(skip(1)).subscribe(appState => {
      this.identityService.clearHistory();
      if (this.app) {
        this.router.navigateByUrl(`${this.app.venueId}/signout`);
      }
    });
    const r = await this.authService.logout();
  }

  back() {
    this.identityService.navigateBack();
  }

  getString(s: string, pc = "normal") {
    return this.translate.single(s, pc);
  }

  navtoReceipts() {
    //console.log("navtoReceipts", this.app.venueId);
    if (this.app) {
      this.router.navigateByUrl(`${this.app.venueId}/receipts`);
    }
    return false;
  }
}
